import React from 'react'
import { NavLink } from 'react-router-dom'
import "../styles/Navbar.scss"

function Navbar() {
  return (
    <div className='navbar'> <div className='links'>
        <NavLink to="/" activeclassname="active">Home</NavLink>
        <NavLink to="/about" activeclassame="active">About</NavLink>
        <NavLink to="/projects" activeclassname="active">Projects</NavLink>
        <NavLink to="/contact" activeclassname="active">Contact Me</NavLink>
    </div></div>
  )
}

export default Navbar